import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

function Resume() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('https://raw.githubusercontent.com/ubaidbutt/career/main/README.md')
      .then(response => response.text())
      .then(text => setContent(text))
      .catch(error => console.error('Error loading CV:', error));
  }, []);

  return (
    <div className="page-wrapper">
      <div className="cv-container">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default Resume;